module.exports = __webpack_public_path__ + "static/media/ai-ml.4e3f756b.png";